import React from "react";

export default function SkeletonCard() {
  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div
        className="animate-pulse bg-slate-200 dark:bg-slate-800"
        style={{ aspectRatio: "551 / 617" }}
      />

      <div className="space-y-2 p-3">
        <div className="h-4 w-20 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
        <div className="h-4 w-3/4 animate-pulse rounded bg-slate-200 dark:bg-slate-800" />
        <div className="h-3 w-1/2 animate-pulse rounded bg-slate-200 dark:bg-slate-800" />
      </div>
    </div>
  );
}